import { render, staticRenderFns } from "./b_matchScoreList.vue?vue&type=template&id=5d20ebc0&scoped=true&"
import script from "./b_matchScoreList.vue?vue&type=script&lang=js&"
export * from "./b_matchScoreList.vue?vue&type=script&lang=js&"
import style0 from "./b_matchScoreList.vue?vue&type=style&index=0&id=5d20ebc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d20ebc0",
  null
  
)

export default component.exports